/** Ícono por especialidad (assets del skill). */
export function iconoEspecialidad(nombre: string): string {
  const n = nombre.toLowerCase();
  if (n.includes('pediat')) return '/img/iconos/especialidad-pediatria.png';
  if (n.includes('gine') || n.includes('obst')) return '/img/iconos/especialidad-ginecologia.png';
  if (n.includes('cirug')) return '/img/iconos/especialidad-cirugia.png';
  return '/img/iconos/especialidad-interna.png';
}

/** Clave comparable de una especialidad: `PEDIATRÍA`, `pediatria` y `Medicina Interna` ↔ `medicina-interna`. */
export function claveEspecialidad(nombre: string): string {
  return nombre.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase().replace(/\s+/g, '-');
}
